export default __webpack_public_path__ + "static/media/lk_1.879766a0.jpg";